import { rootApi } from "../../api/rootApi";

export const kycUpdateApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    searchUserKyc: builder.mutation({
      query: (params) => {
        const query = new URLSearchParams();
        Object.entries(params.filters || {}).forEach(([key, value]) => {
          if (value) query.append(key, value);
        });

        return {
          method: "GET",
          url: `/tenant/kyc-update/search?${query.toString()}`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),

    updateKycOfUser: builder.mutation({
      query: (params) => {
        return {
          method: "PUT",
          url: `/app/kyc/update-kyc/${params.app_user_id}`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.data,
        };
      },
    }),

    clearKycOfUser: builder.mutation({
      query: (params) => {
        return {
          method: "PATCH",
          url: `/app/kyc/remove/${params.app_user_id}`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.data,
        };
      },
    }),
  }),
});

export const {
  useSearchUserKycMutation,
  useUpdateKycOfUserMutation,
  useClearKycOfUserMutation,
} = kycUpdateApi;
